export default [
  {
    label: 'Size 0',
    value: 'size0'
  },
  {
    label: 'Size 1',
    value: 'size1'
  },
  {
    label: 'Size 2',
    value: 'size2'
  },
  {
    label: 'Size 3',
    value: 'size3'
  },
  {
    label: 'Size 4',
    value: 'size4'
  },
  {
    label: 'Size 5',
    value: 'size5'
  },
  {
    label: 'Size 6',
    value: 'size6'
  },
  {
    label: 'Size 7',
    value: 'size7'
  },
  {
    label: '2T - 3T',
    value: 'training23'
  },
  {
    label: '3T - 4T',
    value: 'training34'
  },
  {
    label: '4T - 5T',
    value: 'training45'
  },
  {
    label: '5T - 6T',
    value: 'training56'
  },
  {
    label: 'X-Small',
    value: 'trainingxsmall'
  },
  {
    label: 'Small/Medium',
    value: 'trainingsmallmedium'
  },
  {
    label: 'Large/X-Large',
    value: 'traininglargexlarge'
  }
];
